export function totalBytes(blobs: Blob[]): number {
  return blobs.reduce((acc, blob) => acc + blob.size, 0)
}
